import React from 'react'
import './footer.css'

const footer = () => {
  return (
  <footer className='footer'>
    Copyright &#169; 2023 Riya Kumari. All right reserved.
  </footer>
  )
}

export default footer
